export default "/v8.62.0/52c0ae7/bundles/opensearch.xml";